module.exports = __webpack_public_path__ + "static/media/pending_empty_mobile.76e04b3d.svg";